<template>
  <Jobs source="/reports/jobs" />
</template>

<script setup lang="ts">
import Jobs from "@/Reports/Jobs.vue";
</script>

<style scoped></style>
